import MotifRefusAdmissionController from './motif.refus.admission.controller';

export default {
    template: require('./motif.refus.admission.html'),
    controller: MotifRefusAdmissionController
};
